import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pageTitle: "",
  imageURL: "",
  allAddressList: "",
  allAddressList: "",
  getStates: "",
  getCity: "",
  shippingCost: "",
  userRewards: 0,
  isDisabled: false,
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setPageTitle: (state, action) => {
      state.pageTitle = action.payload;
    },
    uploadImageRequest: (state) => {
      state.isLoading = true; // Set isLoading to true when login request starts
    },
    uploadImageSuccess: (state, action) => {
      state.imageURL = action.payload;
      state.isLoading = false; // Set isLoading to false after successful login
    },
    uploadImageFailure: (state) => {
      state.isLoading = false; // Set isLoading to false if login fails
    },
    setAddressList: (state, action) => {
      state.allAddressList = action.payload;
    },
    setUserProfile: (state, action) => {
      state.userDetail = action.payload;
    },
    setCountryStates: (state, action) => {
      state.getStates = action.payload;
    },
    setStateCity: (state, action) => {
      state.getCity = action.payload;
    },
    isDisabled: (state, action) => {
      state.isDisabled = action.payload;
    },
    setShippingCharges: (state, action) => {
      state.shippingCost = action.payload;
    },
    setRewardsPoints: (state, action) => {
      state.userRewards = action.payload;
    },
  },
});

export const {
  setPageTitle,
  uploadImageRequest,
  uploadImageSuccess,
  uploadImageFailure,
  setAddressList,
  setUserProfile,
  setCountryStates,
  setStateCity,
  isDisabled,
  setShippingCharges,
  setRewardsPoints
} = commonSlice.actions;

export default commonSlice.reducer;
